import { S3Client, GetObjectCommand } from '@aws-sdk/client-s3';

const bucketName = process.env.REACT_APP_AWS_S3_BUCKET || 'eazylink-images';
const region = process.env.REACT_APP_AWS_REGION || 'us-east-1';

let s3Client = null;

const getS3Client = () => {
  const accessKeyId = process.env.REACT_APP_AWS_ACCESS_KEY_ID;
  const secretAccessKey = process.env.REACT_APP_AWS_SECRET_ACCESS_KEY;

  if (!accessKeyId || !secretAccessKey) {
    console.warn(
      '[S3] Missing REACT_APP_AWS_ACCESS_KEY_ID or REACT_APP_AWS_SECRET_ACCESS_KEY'
    );
    return null;
  }

  if (!s3Client) {
    s3Client = new S3Client({
      region,
      credentials: {
        accessKeyId,
        secretAccessKey,
      },
    });
  }

  return s3Client;
};

const normalizeObjectKey = (objectKey) => String(objectKey).trim().replace(/^\//, '');

/**
 * Fetches an object from S3 and returns a blob URL for use in img src.
 * Mirrors admin portal @/lib/s3 getFileUrl (fetchS3File).
 */
export async function getFileUrl(objectKey) {
  if (!objectKey) return undefined;

  const key = normalizeObjectKey(objectKey);
  if (/^https?:\/\//i.test(key) || key.startsWith('blob:') || key.startsWith('data:')) {
    return key;
  }

  const client = getS3Client();
  if (!client) return undefined;

  try {
    const response = await client.send(
      new GetObjectCommand({
        Bucket: bucketName,
        Key: key,
      })
    );

    if (!response?.Body) return undefined;

    const bytes = await response.Body.transformToByteArray();
    const contentType = response.ContentType || guessContentType(key);
    const blob = new Blob([bytes], { type: contentType });
    return URL.createObjectURL(blob);
  } catch (err) {
    console.error('[S3] Error fetching file:', key, err);
    return undefined;
  }
}

function guessContentType(key) {
  const lower = key.toLowerCase();
  if (lower.endsWith('.png')) return 'image/png';
  if (lower.endsWith('.webp')) return 'image/webp';
  if (lower.endsWith('.gif')) return 'image/gif';
  if (lower.endsWith('.avif')) return 'image/avif';
  if (lower.endsWith('.jpg') || lower.endsWith('.jpeg')) return 'image/jpeg';
  return 'image/jpeg';
}

export function revokeFileUrl(url) {
  if (url && typeof url === 'string' && url.startsWith('blob:')) {
    URL.revokeObjectURL(url);
  }
}
